import { axios } from '@repo/http';
import { currentUserOrganizationListKeys } from '@repo/query-keys/user';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CREATE_ORG_PATH } from 'ze-api-contract/organization-v2/crud-organization';
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export function useCreateOrganization() {
    const queryClient = useQueryClient();
    const queryKey = currentUserOrganizationListKeys.available.queryKey;
    return useMutation({
        mutationFn: (organization)=>axios.post(CREATE_ORG_PATH, organization),
        onSuccess: async ()=>{
            await queryClient.invalidateQueries({
                queryKey
            });
        }
    });
}
